// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7234) return "static/chunks/7234.4406ee608c9ec99f.js";
	if (chunkId === 4104) return "static/chunks/4104.77e35bd700939d97.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1908":"8eab1d46cc3cf91c","2184":"f1c2afc8ded6bc72","7522":"83771028b6502f51","9228":"4c3fea9ad938cbae"}[chunkId] + ".js";
};